<template>

  <div class="software">
    <div class="background">
      <div class="background-img"><img :src="img_1" style="width:450px;height:340px"></div>
      <div class="background-text">
        <p>软件定制</p>
      </div>
    </div>
<!--      <img :src="top" alt="核心业务banner" style="width: 100%;height: 450px">-->
    <div class="con_data">
      <!-- 核心业务板块 -->
      <div class="section core-section">
        <div class="section-header">
          <h2 class="section-title">核心业务</h2>
          <div class="section-divider"></div>
          <p class="section-subtitle">专业的技术团队，为您提供全方位的智能解决方案</p>
        </div>
        
        <div class="core">
          <div class="core-item" data-aos="fade-up" data-aos-delay="100">
            <div class="core-icon">
              <img src="../../assets/icon01.png" alt="物联网应用建设">
            </div>
            <div class="core-content">
              <h3>物联网应用建设</h3>
              <p>智砼兴华智能自有物联网研发团队，在工业4.0、环境监测、智能应用、无线通讯等拥有自有研发成果,其广泛应用于智慧工厂、智慧楼宇、智慧农业、智慧旅游、智慧管廊等智慧城市建设领域。</p>
              <div class="core-more">
                <el-button type="text">了解更多 <i class="el-icon-arrow-right"></i></el-button>
              </div>
            </div>
          </div>
          
          <div class="core-item" data-aos="fade-up" data-aos-delay="200">
            <div class="core-icon">
              <img src="../../assets/icon02.png" alt="政务信息化建设">
            </div>
            <div class="core-content">
              <h3>政务信息化建设</h3>
              <p>智砼兴华智能为政企单位提供从专线服务、综合布线、无线覆盖、视频监控到云服务、企业门户搭建、办公OA、ERP建设。全面解决企业在运营中面临的各种需求,并提供完善的售后服务。自公司成立以来,服务大中小企业数百家,获得企业客户高度认可及评价。</p>
              <div class="core-more">
                <el-button type="text">了解更多 <i class="el-icon-arrow-right"></i></el-button>
              </div>
            </div>
          </div>
          
          <div class="core-item" data-aos="fade-up" data-aos-delay="300">
            <div class="core-icon">
              <img src="../../assets/icon03.png" alt="企业智能制造">
            </div>
            <div class="core-content">
              <h3>企业智能制造</h3>
              <p>智砼兴华智能的智能制造系统搭建在企业原有自动化控制系统之上,结合各类传感器、控制器、AI识别等技术,对生产制造过程进行透明化监控，推动人机协作,并对生产制造过程进行智能分析、推理、诊断和决策,从而实现企业生产智能运行、降本增效。</p>
              <div class="core-more">
                <el-button type="text">了解更多 <i class="el-icon-arrow-right"></i></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 合作流程板块 -->
      <div class="section flow-section">
        <div class="section-header">
          <h2 class="section-title">合作流程</h2>
          <div class="section-divider"></div>
          <p class="section-subtitle">
            如果您在购买系统产品后有任何不满意，我们支持5天内无理由退订。<br>
            您可以拨打热线电话（4008818145或18574931510）或者通过退订管理进行操作
          </p>
        </div>
        
        <div class="flow-process">
          <div class="process-item" data-aos="zoom-in" data-aos-delay="100">
            <div class="process-icon">
              <img src="../../assets/icon04.png" alt="初步了解">
              <div class="process-number">01</div>
            </div>
            <h4>初步了解</h4>
            <p>PROCESS</p>
            <div class="process-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <div class="process-item" data-aos="zoom-in" data-aos-delay="200">
            <div class="process-icon">
              <img src="../../assets/icon05.png" alt="现场洽谈">
              <div class="process-number">02</div>
            </div>
            <h4>现场洽谈</h4>
            <p>NEGOTIATION</p>
            <div class="process-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <div class="process-item" data-aos="zoom-in" data-aos-delay="300">
            <div class="process-icon">
              <img src="../../assets/icon06.png" alt="确认合作">
              <div class="process-number">03</div>
            </div>
            <h4>确认合作</h4>
            <p>COOPERATION</p>
            <div class="process-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <div class="process-item" data-aos="zoom-in" data-aos-delay="400">
            <div class="process-icon">
              <img src="../../assets/icon07.png" alt="系统培训">
              <div class="process-number">04</div>
            </div>
            <h4>系统培训</h4>
            <p>TRAIN</p>
            <div class="process-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          
          <div class="process-item" data-aos="zoom-in" data-aos-delay="500">
            <div class="process-icon">
              <img src="../../assets/icon08.png" alt="售后服务">
              <div class="process-number">05</div>
            </div>
            <h4>售后服务</h4>
            <p>AFTER SALE</p>
          </div>
        </div>
      </div>

      <!-- 服务政策板块 -->
      <div class="section service-section">
        <div class="section-header">
          <h2 class="section-title">服务政策</h2>
          <div class="section-divider"></div>
          <p class="section-subtitle">向客户提供一流的产品，完善的服务</p>
        </div>
        
        <div class="service-cards">
          <div class="service-card" data-aos="flip-left" data-aos-delay="100">
            <div class="card-icon">
              <img src="../../assets/icon09.png" alt="技术培训">
            </div>
            <h4>技术培训</h4>
            <p>为客户提供产品技术性能培训、咨询</p>
            <div class="card-hover">
              <div class="hover-content">
                <h4>技术培训</h4>
                <p>我们提供专业的技术培训，确保您的团队能够充分利用我们的产品和服务。</p>
                <el-button type="primary" size="small" round>联系我们</el-button>
              </div>
            </div>
          </div>
          
          <div class="service-card" data-aos="flip-left" data-aos-delay="200">
            <div class="card-icon">
              <img src="../../assets/icon10.png" alt="技术支持">
            </div>
            <h4>技术支持</h4>
            <p>为客户提供产品技术性能培训、咨询</p>
            <div class="card-hover">
              <div class="hover-content">
                <h4>技术支持</h4>
                <p>我们的技术团队随时为您提供支持，解决您在使用过程中遇到的任何问题。</p>
                <el-button type="primary" size="small" round>联系我们</el-button>
              </div>
            </div>
          </div>
          
          <div class="service-card" data-aos="flip-left" data-aos-delay="300">
            <div class="card-icon">
              <img src="../../assets/icon11.png" alt="售后保障">
            </div>
            <h4>售后保障</h4>
            <p>为客户提供产品技术性能培训、咨询</p>
            <div class="card-hover">
              <div class="hover-content">
                <h4>售后保障</h4>
                <p>我们提供全面的售后保障服务，确保您的系统稳定运行，解决后顾之忧。</p>
                <el-button type="primary" size="small" round>联系我们</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 联系我们板块 -->
      <div class="section contact-section">
        <div class="contact-content">
          <h2>需要专业的智能解决方案？</h2>
          <p>我们的专业团队随时为您提供咨询服务</p>
          <el-button type="primary" size="large" round @click="showConsultDialog">立即咨询</el-button>
        </div>
      </div>
    </div>
    
    <!-- 咨询弹框 -->
    <el-dialog
      title="请您留言"
      :visible.sync="dialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form ref="formName" :model="form" :rules="rules">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item prop="addr">
          <el-input v-model="form.addr" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item prop="message">
          <el-input type="textarea" v-model="form.message" rows="4" placeholder="请输入咨询内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "software",
  data(){
    return{
      top:'',
      dialogVisible: false,
      img_1:require('../../assets/06.png'),
      form:{
        name:'',
        phone:'',
        addr:'',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        addr: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入咨询内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getTop();
    // 如果使用AOS动画库，需要在这里初始化
    // 如果没有安装AOS，可以移除data-aos相关属性
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true
      });
    }
  },
  methods:{
    getTop(){
      let data={params:{ImgCate:8}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    // 显示咨询弹框
    showConsultDialog() {
      this.dialogVisible = true;
    },
    // 关闭弹框
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 提交表单
    submitForm() {
      this.$refs.formName.validate((valid) => {
        if (valid) {
          // 这里可以添加提交表单的逻辑
          this.$message.success('提交成功，我们将尽快与您联系！');
          this.dialogVisible = false;
          // 重置表单
          this.$refs.formName.resetFields();
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
/* 页面整体样式 */
.software {
  background-color: #f9f9fa;
  color: #333;
}

/* 顶部banner */
.top {
  position: relative;
  height: 450px;
  overflow: hidden;
}

.top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3));
  display: flex;
  align-items: center;
}

.banner-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.banner-content h1 {
  font-size: 48px;
  font-weight: 600;
  color: white;
  margin-bottom: 15px;
  animation: fadeInLeft 1s ease;
}

.banner-content p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  animation: fadeInLeft 1s ease 0.3s;
  animation-fill-mode: both;
}

/* 内容区域通用样式 */
.con_data {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
  border-bottom: 1px solid #eee;
}

.section:last-child {
  border-bottom: none;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 15px;
}

.section-divider {
  width: 60px;
  height: 3px;
  background: #1890ff;
  margin: 0 auto 20px;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

/* 核心业务板块 */
.core {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.core-item {
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.core-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.core-icon {
  width: 180px;
  background: #f0f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  transition: all 0.3s ease;
}

.core-item:hover .core-icon {
  background: #1890ff;
}

.core-icon img {
  width: 80px;
  height: auto;
  transition: all 0.3s ease;
}

.core-item:hover .core-icon img {
  filter: brightness(0) invert(1);
  transform: scale(1.1);
}

.core-content {
  flex: 1;
  padding: 30px;
}

.core-content h3 {
  font-size: 22px;
  margin-bottom: 15px;
  color: #333;
}

.core-content p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.core-more {
  text-align: right;
}

.core-more .el-button {
  color: #1890ff;
  font-weight: 500;
}

.core-more .el-button i {
  transition: transform 0.3s ease;
}

.core-more .el-button:hover i {
  transform: translateX(5px);
}

/* 合作流程板块 */
.flow-process {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  position: relative;
}

.process-item {
  text-align: center;
  position: relative;
  width: 18%;
}

.process-icon {
  position: relative;
  width: 100px;
  height: 100px;
  background: white;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.process-item:hover .process-icon {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.process-icon img {
  width: 50px;
  height: auto;
}

.process-number {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 30px;
  height: 30px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

.process-item h4 {
  font-size: 18px;
  margin-bottom: 5px;
  color: #333;
}

.process-item p {
  color: #999;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.process-arrow {
  position: absolute;
  top: 40px;
  right: -15px;
  color: #ddd;
  font-size: 24px;
  z-index: 1;
}

.process-item:last-child .process-arrow {
  display: none;
}

/* 服务政策板块 */
.service-cards {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.service-card {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px);
}

.card-icon {
  margin-bottom: 20px;
}

.card-icon img {
  width: 60px;
  height: auto;
}

.service-card h4 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

.card-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(24, 144, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
}

.service-card:hover .card-hover {
  opacity: 1;
}

.hover-content {
  padding: 30px;
  color: white;
}

.hover-content h4 {
  color: white;
  margin-bottom: 15px;
}

.hover-content p {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 20px;
}

/* 联系我们板块 */
.contact-section {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  border-radius: 8px;
  margin: 80px 0;
  padding: 0 !important;
}

.contact-content {
  padding: 60px;
  text-align: center;
  color: white;
}

.contact-content h2 {
  font-size: 28px;
  margin-bottom: 15px;
}

.contact-content p {
  font-size: 16px;
  margin-bottom: 30px;
  opacity: 0.9;
}

/* 动画 */
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .core-item {
    flex-direction: column;
  }
  
  .core-icon {
    width: 100%;
    padding: 20px;
  }
  
  .flow-process {
    flex-wrap: wrap;
    justify-content: center;
    gap: 40px;
  }
  
  .process-item {
    width: 45%;
  }
  
  .process-arrow {
    display: none;
  }
  
  .service-cards {
    flex-direction: column;
  }
  
  .banner-content h1 {
    font-size: 36px;
  }
}

@media (max-width: 768px) {
  .section {
    padding: 50px 0;
  }
  
  .section-title {
    font-size: 28px;
  }
  
  .process-item {
    width: 100%;
    margin-bottom: 30px;
  }
  
  .contact-content {
    padding: 40px 20px;
  }
  
  .contact-content h2 {
    font-size: 24px;
  }
}
/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 60%;
  top: -15px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 27%;
  top: -300px;
}
</style>